module.exports = __webpack_public_path__ + "img/Cycling.a7899fa6.png";